<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 0.41rem 0px;
      position: relative;
    "
  >
    <draggable
      :list="videoDataList"
      item-key="id"
      class="list-group"
      animation="300"
      :move="onMove"
      @update="updateCell"
      @end="endCell"
      @choose="chooseCell"
    >
      <template #item="{ element, index }">
        <div :class="cellClass(index)" style="z-index: 100">
          <div
            v-if="
              element.isFlv === true ||
              element.isFlv === '' ||
              element.isFlv === null ||
              element.isFlv === undefined
                ? true
                : false
            "
            style="
              width: 100%;
              height: 100%;
              border: 1px solid white;
              color: white;
              text-align: center;
            "
            :id="element.id"
            :key="element.id"
            @click="smallToBig(index, element)"
          ></div>
          <video
            v-if="element.isFlv === false ? true : false"
            :id="element.id"
            :key="element.id"
            ref="containerVideo"
            style="
              width: 100%;
              height: 100%;
              border: 1px solid white;
              color: white;
              text-align: center;
              object-fit: fill;
            "
            controls
            autoplay
          ></video>
          <div
            v-if="
              element.liveName === null || element.liveName === undefined
                ? false
                : true
            "
            class="position_top clearfix"
          >
            <div class="fl">
              <div class="title">
                <el-tooltip
                  class="box-item"
                  effect="dark"
                  :disabled="
                    element.deviceSn.length + element.liveName.length < 15
                  "
                  :content="element.deviceSn + ' - ' + element.liveName"
                  placement="bottom-start"
                >
                  <span>{{ element.deviceSn }} - {{ element.liveName }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="fr">
              <div class="icon_con_close hover_opacity">
                <span
                  @click="closeVideo(element)"
                  class="iconfont icon-guanbi"
                ></span>
              </div>
            </div>
          </div>
          <div
            v-if="
              element.liveName === null || element.liveName === undefined
                ? false
                : true
            "
            class="position_bottom clearfix"
          >
            <div class="fl">
              <div
                style="
                  height: 38px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="height: auto; margin: auto">
                  <span
                    style="
                      height: 17px;
                      color: #197ad7;
                      font-size: 0.9rem;
                      line-height: 17px;
                    "
                    >{{ t('1153') }}：</span
                  >
                </div>

                <div class="icon_con hover_opacity">
                  <el-dropdown @command="openDropdown($event, element, index)">
                    <span
                      style="
                        display: inline-block;
                        height: 17px;
                        color: #197ad7;
                        font-size: 1rem;
                        margin-top: 0.1rem;
                      "
                      >{{ element.isFlv === true ? "flv" : "rtc" }}</span
                    >
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="flv">flv</el-dropdown-item>
                        <el-dropdown-item command="rtc">rtc</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </draggable>

    <template v-for="(i, index) in 4" :key="index">
      <div :class="cellClass(index)" v-if="cellCount === 4 ? true : false">
        <div
          style="
            height: 100%;
            border: 0.5px solid white;
            color: white;
            text-align: center;
          "
          :id="i.id"
        ></div>
      </div>
    </template>
    <template v-for="(i, index) in 8" :key="index">
      <div
        :class="cellClass(index)"
        v-if="cellCount === 8 && !isDraging ? true : false"
      >
        <div
          style="
            height: 100%;
            border: 1px solid white;
            color: white;
            text-align: center;
          "
          :id="i.id"
        ></div>
      </div>
    </template>
  </div>
</template>
<script>
import { t } from '../../../languages';
import {
  defineComponent,
  onMounted,
  onUpdated,
  onUnmounted,
  onBeforeUnmount,
  reactive,
  toRefs,
  watch,
  computed,
  ref,
  nextTick,
} from "vue";
import taskManage from "../../../network/task";
import emitter from "../../../utils/mitt";
import { ElMessage } from "element-plus";
import draggable from "vuedraggable";
export default defineComponent({
  components: { draggable },
  props: {
    cellCount: {
      type: Number,
      default: 4,
    },
    startData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    videoData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    videoDataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  emits: ["smallToBig", "closeVideo"],
  setup(props, { emit }) {
    const { startData, cellCount, videoData, videoDataList } = toRefs(props);

    watch(
      () => props.cellCount,
      (val, prevVal) => {
        if (val === 8) {
          let playerArr2 = new Array();
          for (const key in player) {
            playerArr2.push(key);
          }
          videoDataList.value.forEach((e) => {
            if (!playerArr2.includes(e.id)) {
              nextTick(() => {
                createPlayer(e.id, e.liveRtmpPath);
                player[e.id].play(e.liveRtmpPath);
              });
            }
          });
        } else {
          let playerArr = new Array();
          videoDataList.value.forEach((e) => {
            playerArr.push(e.id);
          });
          if (playerArr.length < Object.keys(player).length) {
            for (const key in player) {
              if (!playerArr.includes(key)) {
                if (player[key]) {
                  player[key].destroy();
                  delete player[key];
                }
              }
            }
          }
        }
      }
    ),
      emitter.on("destoryJes", (data) => {
        let playerArr = new Array();
        for (const key in player) {
          playerArr.push(key);
        }
        //关闭正在播放的
        if (playerArr.includes(data)) {
          player[data].destroy();
          delete player[data];
          if (videoDataList.value.length === 4) {
            nextTick(() => {
              let playerArr = new Array(4);
              for (const key in player) {
                if (key) {
                  playerArr.push(key);
                }
              }
              videoDataList.value.forEach((e) => {
                if (!playerArr.includes(e.id)) {
                  createPlayer(e.id, e.liveRtmpPath);
                  player[e.id].play(e.liveRtmpPath);
                }
              });
            });
          } else if (videoDataList.value.length === 8) {
            nextTick(() => {
              let playerArr = new Array(8);
              for (const key in player) {
                if (key) {
                  playerArr.push(key);
                }
              }
              videoDataList.value.forEach((e) => {
                if (!playerArr.includes(e.id)) {
                  createPlayer(e.id, e.liveRtmpPath);
                  player[e.id].play(e.liveRtmpPath);
                }
              });
            });
          }
        } else {
          nextTick(() => {
            //关闭不在播放中的
            let playerArr = [];
            for (const key in player) {
              if (key) {
                playerArr.push(key);
              }
            }
            let playerArr2 = new Array(4);
            videoDataList.value.forEach((e) => {
              playerArr2.push(e.id);
              if (!playerArr.includes(e.id)) {
                createPlayer(e.id, e.liveRtmpPath);
                player[e.id].play(e.liveRtmpPath);
              }
            });
            playerArr.forEach((e) => {
              if (!playerArr2.includes(e)) {
                player[e].destroy();
                delete player[e];
              }
            });
          });
        }
      });
    emitter.on("tabChange", (data) => {
      tabChangeInitPlayer(data);
    });
    const isCreatePlayer = ref(true);
    onUnmounted(() => {
      isCreatePlayer.value = false;
      for (const key in player) {
        if (key) {
          player[key].destroy();
          delete player[key];
        }
      }
    });
    onBeforeUnmount(() => {
      emitter.off("changeStatus");
      emitter.off("createPlayerFooter");
      emitter.off("addJes");
      emitter.off("destoryJes");
    });
    let cellClass = computed(() => {
      return function (index) {
        switch (cellCount.value) {
          case 1:
            return ["player-w1"];
          case 2:
            return ["player-w2"];
          case 3:
            if (index == 0) return ["player-w3-1"];
            return ["player-w3-2"];
          case 4:
            return ["player-w4"];
          case 6:
            if (index == 0) return ["player-w6-1"];
            return ["player-w6-2"];
          case 8:
            if (index == 0) return ["player-w8-1"];
            return ["player-w8-2"];
          case 9:
            return ["player-9"];
          case 16:
            return ["player-16"];
          default:
            break;
        }
      };
    });
    const methods = reactive({
      closeVideo(data) {
        emit("closeVideo", data);
        emitter.emit("changeStatus", data);
        if (player[data.id]) {
          player[data.id].destroy();
          delete player[data.id];
        }
        if (videoDataList.value.length === 4) {
          nextTick(() => {
            let playerArr = new Array(4);
            for (const key in player) {
              if (key) {
                playerArr.push(key);
              }
            }
            videoDataList.value.forEach((e) => {
              if (!playerArr.includes(e.id)) {
                createPlayer(e.id, e.liveRtmpPath);
                player[e.id].play(e.liveRtmpPath);
              }
            });
          });
        } else if (videoDataList.value.length === 8) {
          nextTick(() => {
            let playerArr = new Array(8);
            for (const key in player) {
              if (key) {
                playerArr.push(key);
              }
            }
            videoDataList.value.forEach((e) => {
              if (!playerArr.includes(e.id)) {
                createPlayer(e.id, e.liveRtmpPath);
                player[e.id].play(e.liveRtmpPath);
              }
            });
          });
        }
        let tempData = JSON.parse(sessionStorage.getItem("videoArr"));
        if (tempData) {
          tempData.forEach((e, index) => {
            if (e === data.id) {
              tempData.splice(index, 1);
            }
          });
        }
        let tempDataUav = JSON.parse(sessionStorage.getItem("videoArrUav"));
        if (tempDataUav) {
          tempDataUav.forEach((e, index) => {
            if (e === data.id) {
              tempDataUav.splice(index, 1);
            }
          });
        }
        sessionStorage.setItem("videoArr", JSON.stringify(tempData));
        sessionStorage.setItem("videoArrUav", JSON.stringify(tempDataUav));
        let tempData2 = JSON.parse(sessionStorage.getItem("streamingList"));
        tempData2.forEach((e) => {
          e.liveInfoList.forEach((item) => {
            if (item.id === data.id) {
              item.isAdd = false;
            }
          });
        });
        sessionStorage.setItem("streamingList", JSON.stringify(tempData2));
        let tempDataUav2 = JSON.parse(
          sessionStorage.getItem("streamingListUav")
        );
        if (tempDataUav2) {
          tempDataUav2.forEach((e) => {
            e.liveInfoList.forEach((item) => {
              if (item.id === data.id) {
                item.isAdd = false;
              }
            });
          });
          sessionStorage.setItem(
            "streamingListUav",
            JSON.stringify(tempDataUav2)
          );
        }
      },
    });
    emitter.on("createPlayerFooter", (data) => {
      nextTick(() => {
        nextTick(() => {
          createPlayer(data[0].id, data[0].liveRtmpPath);
          player[data[0].id].play(data[0].liveRtmpPath);
        });
      });
      if (player[data[1].id]) {
        player[data[1].id].destroy();
        delete player[data[1].id];
      }
    });
    // 1561646708930711554
    let player = {}; //装载播放器实例
    function createPlayer(elId) {
      player[elId] = new window.Jessibuca({
        container: document.getElementById(elId),
        videoBuffer: 0.2, // 缓存时长
        isResize: false,
        text: "",
        loadingText: t("957"),
        debug: false,
        supportDblclickFullscreen: true,
        // hasAudio: false,
        isFlv: true,
        operateBtns: {
          fullscreen: true,
          screenshot: true,
          play: true,
          audio: true,
          record: true,
        },
        forceNoOffscreen: true,
        isNotMute: false,
        timeout: 5,
      });
      // player[elId].on("loadingTimeout", function () {
      //             setTimeout(()=>{
      //               if (player[elId]) {
      //               player[elId].play()
      //               }
      //             },2500)
      //           })
      if (player[elId]) {
        player[elId].on("delayTimeout", function () {
          player[elId].clearView();
          player[elId].play();
        });
        player[elId].on("error", function (error) {
          if (error === "websocketError") {
            if (videoDataList.value.length !== 0) {
              if (
                videoDataList.value[
                  videoDataList.value.findIndex((item) => item.id == elId)
                ] !== undefined
              ) {
                videoDataList.value[
                  videoDataList.value.findIndex((item) => item.id == elId)
                ].flag =
                  videoDataList.value[
                    videoDataList.value.findIndex((item) => item.id == elId)
                  ].flag + 1;
                if (
                  videoDataList.value[
                    videoDataList.value.findIndex((item) => item.id == elId)
                  ].flag === 3
                ) {
                  if (player[elId]) {
                    player[elId].destroy();
                  }
                  for (let i = 0; i < videoDataList.value.length; i++) {
                    if (videoDataList.value[i].id === elId) {
                      createPlayer(videoDataList.value[i].id);
                      if (isCreatePlayer.value) {
                        videoDataList.value[
                          videoDataList.value.findIndex(
                            (item) => item.id == elId
                          )
                        ].flag = 0;
                        setTimeout(() => {
                          player[videoDataList.value[i].id].play(
                            videoDataList.value[i].liveRtmpPath
                          );
                        }, 1500 * (videoDataList.value.findIndex((item) => item.id == elId) + 1));
                      }
                    }
                  }
                  // videoDataList.value.forEach(e=>{
                  //   if(e.id === elId){
                  //     if (isCreatePlayer.value) {
                  //       setTimeout(() => {
                  //         createPlayer(e.id);
                  //         player[e.id].play(e.liveRtmpPath);
                  //         videoDataList.value[videoDataList.value.findIndex( item => item.id == elId)].flag = 0
                  //       }, 5000);
                  //     }
                  //   }
                  // })
                }
              }
            }
          }
        });
      }
    }
    //保存状态到内存中
    function saveStatus(params, status, id) {
      let tempData = JSON.parse(sessionStorage.getItem("streamingList"));
      if (tempData) {
        tempData.forEach((e) => {
          e.liveInfoList.forEach((item) => {
            if (item.id === id) {
              item[params] = status;
            }
          });
        });
        sessionStorage.setItem("streamingList", JSON.stringify(tempData));
      }

      let tempDataUav = JSON.parse(sessionStorage.getItem("streamingListUav"));
      if (tempDataUav) {
        tempDataUav.forEach((e) => {
          e.liveInfoList.forEach((item) => {
            if (item.id === id) {
              item[params] = status;
            }
          });
        });
        sessionStorage.setItem("streamingListUav", JSON.stringify(tempDataUav));
      }
    }
    //暂停
    function pause(data, index) {
      if (data.isFlv) {
        if (player[data.id]) {
          player[data.id]
            .pause()
            .then(() => {
              videoDataList.value[index].isPause = false;
              saveStatus("isPause", false, data.id);
            })
            .catch((e) => {
              console.log("pause error", e);
            });
        }
      } else {
        ElMessage.info(t("1154"));
        videoDataList.value[index].isPause = false;
        document.getElementById(data.id).pause();
        saveStatus("isPause", false, data.id);
      }
    }
    //点击播放
    function play(data, index) {
      if (data.isFlv) {
        videoDataList.value[index].isPause = true;
        saveStatus("isPause", true, data.id);
        player[data.id]
          .play(data.liveRtmpPath)
          .then(() => {
            videoDataList.value[index].isPause = true;
          })
          .catch((e) => {
            videoDataList.value[index].isPause = false;
            // ElMessage.error(t("1155"));
          });
      } else {
        ElMessage.info(t("1156"));
        videoDataList.value[index].isPause = true;
        document.getElementById(data.id).play();
        saveStatus("isPause", true, data.id);
      }
    }
    //点击播放器全屏
    function fullscreen(data) {
      if (data.isFlv) {
        player[data.id].setFullscreen(true);
      } else {
        ElMessage.info(t("1157"));
        let videoBox = document.getElementById(data.id);
        if (videoBox.requestFullscreen) {
          videoBox.requestFullscreen();
        } else if (videoBox.mozRequestFullScreen) {
          videoBox.mozRequestFullScreen();
        } else if (videoBox.webkitRequestFullScreen) {
          videoBox.webkitRequestFullScreen();
        }
      }
    }

    emitter.on("addJes", (data) => {
      let playerArr = new Array(4);
      let playerArr2 = new Array(4);
      if (
        videoDataList.value.length === 4 ||
        videoDataList.value.length === 8
      ) {
        nextTick(() => {
          for (const key in player) {
            if (key) {
              playerArr.push(key);
            }
          }
          videoDataList.value.forEach((e) => {
            playerArr2.push(e.id);
            if (!playerArr.includes(e.id)) {
              createPlayer(e.id, e.liveRtmpPath);
              player[e.id].play(e.liveRtmpPath);
            }
          });
          var c1 = playerArr.filter((a) => {
            return !playerArr2.some((c) => c == a);
          });
          if (c1.length !== 0) {
            if (player[c1[0]]) {
              player[c1[0]].destroy();
              delete player[c1[0]];
            }
          }
        });
      } else {
        nextTick(() => {
          videoDataList.value.forEach((e) => {
            if (e.id === data.id) {
              createPlayer(e.id, e.liveRtmpPath);
              player[e.id].play(e.liveRtmpPath);
            }
          });
        });
      }
    });
    function tabChangeInitPlayer(data) {
      data.forEach((e) => {
        if (e.liveRtmpPath.split(":")[0] !== "ws") {
          let middle = e.liveRtmpPath.replace("rtmp", "ws");
          if (middle.lastIndexOf(":") < 4) {
            const urlAdress = middle.concat(".flv");
            e.liveRtmpPath = urlAdress;
          } else {
            const urlAdress = middle
              .replace(
                middle.split(":")[2].split("/")[0],
                e.rtcApi + "/jessica"
              )
              .concat(".flv");
            e.liveRtmpPath = urlAdress;
          }
          setTimeout(() => {
            createPlayer(e.id);
            player[e.id].play(e.liveRtmpPath);
          }, 300);
        }
      });
    }
    let arr = [];
    //实例化播放器
    function initPlayer() {
      for (let i = 0; i < videoDataList.value.length; i++) {
        createPlayer(videoDataList.value[i].id);
        setTimeout(() => {
          player[videoDataList.value[i].id].play(
            videoDataList.value[i].liveRtmpPath
          );
        }, 1200 * i);
      }
      // })
      return;
      if (videoDataList.value.length !== 0) {
        if (videoDataList.value.length > arr.length) {
          //增加
          let arr3 = videoDataList.value.filter((v) => {
            return arr.every((e) => e.id != v.id);
          });
          if (arr3.length > 0) {
            for (let i = 0; i < arr3.length; i++) {
              if (arr3[i].id !== undefined) {
                createPlayer(arr3[i].id, arr3[i].liveRtmpPath);
                player[arr3[i].id].play(arr3[i].liveRtmpPath);
                player[arr3[i].id].on("loadingTimeout", function () {
                  setTimeout(() => {
                    if (player[arr3[i].id]) {
                      player[arr3[i].id].play(arr3[i].liveRtmpPath);
                    }
                  }, 2500);
                });
                if (player[arr3[i].id]) {
                  player[arr3[i].id].on("delayTimeout", function () {
                    player[arr3[i].id].clearView();
                    player[arr3[i].id].play(arr3[i].liveRtmpPath);
                  });
                }
              }
            }
          } else {
            nextTick(() => {
              createPlayer(arr3[0].id);
              player[arr3[0].id].play(arr3[0].liveRtmpPath);
              player[arr3[0].id].on("loadingTimeout", function () {
                setTimeout(() => {
                  if (player[arr3[0].id]) {
                    player[arr3[0].id].play(arr3[0].liveRtmpPath);
                  }
                }, 2500);
              });
              if (player[arr3[0].id]) {
                player[arr3[0].id].on("delayTimeout", function () {
                  player[arr3[0].id].clearView();
                  player[arr3[0].id].play(arr3[0].liveRtmpPath);
                });
              }
            });
          }
        }
        arr = JSON.parse(JSON.stringify(videoDataList.value));
      } else {
        arr = [];
      }
    }
    //静音
    function mute(data, index) {
      if (data.isFlv) {
        player[data.id].mute();
        videoDataList.value[index].isMute = false;
        saveStatus("isMute", false, data.id);
      } else {
        ElMessage.info(t("1158"));
        videoDataList.value[index].isMute = false;
        document.getElementById(data.id).muted = true;
        saveStatus("isMute", false, data.id);
      }
    }
    //取消静音
    function cancelMute(data, index) {
      if (data.isFlv) {
        player[data.id].cancelMute();
        videoDataList.value[index].isMute = true;
        saveStatus("isMute", true, data.id);
      } else {
        ElMessage.info(t("1159"));
        videoDataList.value[index].isMute = true;
        document.getElementById(data.id).muted = false;
        saveStatus("isMute", true, data.id);
      }
    }
    //截图
    function jietu(data) {
      if (data.isFlv) {
        player[data.id].screenshot("test", "png", 0.5);
      } else {
        ElMessage.info(t("1160"));
      }
    }
    //录制
    function luzhi(data, index) {
      if (data.isFlv) {
        player[data.id].startRecord("test", "webm");
        videoDataList.value[index].isLuzhi = false;
        saveStatus("isLuzhi", false, data.id);
      } else {
        ElMessage.info(t("1161"));
      }
    }
    //录制中
    function luzhizhon(data, index) {
      if (data.isFlv) {
        player[data.id].stopRecordAndSave();
        videoDataList.value[index].isLuzhi = true;
        saveStatus("isLuzhi", true, data.id);
      } else {
        ElMessage.info(t("1162"));
      }
    }
    //打开flv rtc 切换面板
    function openDropdown(type, data, index) {
      if (type === "rtc") {
        data.isFlv = false;
        data.isLuzhi = true;
        data.isMute = true;
        data.isPause = true;
        saveStatus("isLuzhi", true, data.id);
        saveStatus("isMute", true, data.id);
        saveStatus("isPause", true, data.id);
        saveStatus("isFlv", false, data.id);
        if (player[data.id]) {
          player[data.id].close();
        }
        videoDataList.value.forEach((e) => {
          if (e.id === data.id) {
            e.isVideo = true;
          }
        });

        nextTick(() => {
          let documentEle = document.getElementById(data.id);
          playRtc(data, documentEle);
        });
      } else {
        data.isFlv = true;
        data.isLuzhi = true;
        data.isMute = true;
        data.isPause = true;
        saveStatus("isFlv", true, data.id);
        saveStatus("isLuzhi", true, data.id);
        saveStatus("isMute", true, data.id);
        saveStatus("isPause", true, data.id);
        videoDataList.value.forEach((e) => {
          if (e.id === data.id) {
            e.isVideo = false;
            nextTick(() => {
              createPlayer(data.id);
              player[data.id].play(data.liveRtmpPath);
            });
          }
        });
      }
    }
    function playRtc(data, documentEle) {
      querySdp(data, documentEle)
        .then(async (res) => {
          let submit = {};
          submit.sdp = res;
          submit.liveName = data.liveName;
          submit.nestSn = data.sn;
          submit.type = "offer";
          const response = await taskManage.queryM7sSdp(submit);
          if (response.resultStatus) {
            let tempSdp = response.resultData.sdp;
            await WebrtcObj.value.setRemoteDescription(
              // 在两个对等点之间协商连接的过程涉及来回交换对象，每个描述都表示描述的发送者支持的连接配置选项的一个组合。一旦两个对等方就连接的配置达成一致，协商就完成了。
              new RTCSessionDescription({
                type: "answer",
                sdp: tempSdp,
              })
            );
          }
        })
        .catch((e) => {
          ElMessage.error(t("960"));
        });
    }
    const WebrtcObj = ref(null);
    const containerVideo = ref(null);
    //获取SDP
    async function querySdp(data, documentEle) {
      WebrtcObj.value = new RTCPeerConnection(null);
      // 添加流后赋给vedio进行播放
      WebrtcObj.value.onaddstream = (event) => {
        let video = document.getElementById(data.id);
        video.srcObject = event.stream;
      };
      // addTransceiver()创建一个新的 RTCRtpTransceiver并将其添加到与RTCPeerConnection. 每个收发机表示的双向流，既具有RTCRtpSender和 RTCRtpReceiver与它相关联。
      WebrtcObj.value.addTransceiver("audio", {
        direction: "recvonly",
      });
      WebrtcObj.value.addTransceiver("video", {
        direction: "recvonly",
      });

      // 请求连接
      const offer = await WebrtcObj.value.createOffer();
      // setLocalDescription 存储本地 offer 描述
      await WebrtcObj.value.setLocalDescription(offer);
      return offer.sdp;
    }
    function smallToBig(e, data) {
      if (e > 0 && cellCount.value === 8) {
        nextTick(() => {
          if (player[data.id].isPlaying()) {
            pause(data, e);
            player[data.id].clearView();
            play(data, e);
          }
          if (player[videoDataList.value[0].id].isPlaying()) {
            pause(videoDataList.value[0], 0);
            player[videoDataList.value[0].id].clearView();
            play(videoDataList.value[0], 0);
          }
          //   player[data.id].destroy();
          //   delete player[data.id];
          //   createPlayer(data.id, data.liveRtmpPath);
          //   player[data.id].play(data.liveRtmpPath);
          //   player[data.id].on("loadingTimeout", function () {
          //     setTimeout(()=>{
          //       if (player[data.id]) {
          //             player[data.id].play(data.liveRtmpPath)
          //         }
          //     },2500)
          //   })
          //   if (player[data.id]) {
          //   player[data.id].on("delayTimeout", function () {
          //       player[data.id].clearView()
          //       player[data.id].play(data.liveRtmpPath)
          //   })
          // }
          //   player[videoDataList.value[0].id].destroy();
          //   delete player[videoDataList.value[0].id];
          //   createPlayer(videoDataList.value[0].id, videoDataList.value[0].liveRtmpPath);
          //   player[videoDataList.value[0].id].play(videoDataList.value[0].liveRtmpPath);
          //   player[videoDataList.value[0].id].on("loadingTimeout", function () {
          //     setTimeout(()=>{
          //       if (player[videoDataList.value[0].id]) {
          //             player[videoDataList.value[0].id].play(videoDataList.value[0].liveRtmpPath)
          //         }
          //     },2500)
          //   })
          //   if (player[videoDataList.value[0].id]) {
          //   player[videoDataList.value[0].id].on("delayTimeout", function () {
          //       player[videoDataList.value[0].id].clearView()
          //       player[videoDataList.value[0].id].play(videoDataList.value[0].liveRtmpPath)
          //   })
          // }
          emit("smallToBig", e, data);
        });
      }
    }
    const isDraging = ref(false); //是否正在编辑
    const chooseCellId = ref(""); //被拖拽的对象id
    const changeCellId = ref({}); //被替换的对象id
    //move回调方法
    function onMove(e) {
      isDraging.value = true;
      if (cellCount.value === 4) {
        return;
      }
      if (e.draggedContext.index === 0) {
        e.dragged.className = "player-w8-2";
        e.related.className = "player-w8-2";
      }
      if (e.draggedContext.index === 0) {
        return;
      }
      if (e.draggedContext.futureIndex === 0) {
        e.dragged.className = "player-w8-2";
        e.related.className = "player-w8-2";
        return;
      }
      //false表示阻止拖拽
      return true;
    }
    function chooseCell(e) {
      chooseCellId.value = e.item.firstChild.id;
    }
    function endCell(e) {
      if (cellCount.value === 4) {
        return;
      }
      var w2Class = document.querySelectorAll(".player-w8-1");
      if (w2Class.length === 0) {
        e.target.children[0].className = "player-w8-1";
        let zeroId = e.target.children[0].firstChild.id;
        let changeCellIndex = videoDataList.value.findIndex(
          (item) => item.id === zeroId
        );
        if (changeCellIndex !== -1) {
          if (player[zeroId]) {
            if (player[zeroId].isPlaying()) {
              pause(videoDataList.value[changeCellIndex], changeCellIndex);
              player[zeroId].clearView();
              play(videoDataList.value[changeCellIndex], changeCellIndex);
            }
          }
        }
      }
      isDraging.value = false;
    }
    function updateCell(e) {
      if (cellCount.value === 4) {
        return;
      }
      isDraging.value = false;
      if (e.oldIndex !== 0 && e.newIndex !== 0) {
        changeCellId.value = "";
        chooseCellId.value = "";
        return;
      }
      changeCellId.value = e.target.children[0].firstChild.id;
      let chooseCellIndex = videoDataList.value.findIndex(
        (item) => item.id === chooseCellId.value
      );
      if (chooseCellIndex !== -1) {
        if (player[chooseCellId.value]) {
          if (player[chooseCellId.value].isPlaying()) {
            pause(videoDataList.value[chooseCellIndex], chooseCellIndex);
            player[chooseCellId.value].clearView();
            play(videoDataList.value[chooseCellIndex], chooseCellIndex);
          }
        }
      }
      if (changeCellId.value === chooseCellId.value) {
        changeCellId.value = e.target.children[1].firstChild.id;
      }
      let changeCellIndex = videoDataList.value.findIndex(
        (item) => item.id === changeCellId.value
      );
      if (changeCellIndex !== -1) {
        if (player[changeCellId.value]) {
          if (player[changeCellId.value].isPlaying()) {
            pause(videoDataList.value[changeCellIndex], changeCellIndex);
            player[changeCellId.value].clearView();
            play(videoDataList.value[changeCellIndex], changeCellIndex);
          }
        }
      }
    }
    onMounted(() => {
      setTimeout(() => {
        initPlayer();
      }, 500);
    });
    return {
      cellClass,
      ...toRefs(methods),
      fullscreen,
      pause,
      play,
      isDraging,
      cancelMute,
      mute,
      jietu,
      luzhi,
      luzhizhon,
      openDropdown,
      smallToBig,
      onMove,
      updateCell,
      chooseCell,
      endCell,
    };
  },
});
</script>

<style lang="less" scoped>
video::-webkit-media-controls-fullscreen-button {
  // display: none;
}
//播放按钮
video::-webkit-media-controls-play-button {
  // display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
  // display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  // display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
  // display: none;
}
// 时间轴
video::-webkit-media-controls-timeline {
  // display: none !important;
}
//所有控件
video::-webkit-media-controls-enclosure {
  // display: none;
}
/deep/.jessibuca-container.jessibuca-controls-show .jessibuca-controls {
  background: #000;
  opacity: 0.56;
  visibility: visible;
}
/deep/ .jessibuca-container .jessibuca-icon-pause {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/.jessibuca-container .jessibuca-icon-play {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-fullscreen {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-fullscreenExit {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-mute {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-audio {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-screenshot {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-recordStop {
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon-record {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAE8RJREFUeF7tnW1spFUVgM+d6fIhUQP8Ueh0PztdPkRNEE0w2S0J/hCJ/kExgksDP/AjGhLZTgm4raCdsiREI0oIhNYlBuWPRvGHJGw3kUSJRgUXttP96Ha66B+WiEEW6Mw1t77vMju0nfc999zP90yy6e723nPvPfc87/m4d2YE8Is1wBpYUwOCdcMaYA2srQEGhK2DNbCOBhgQNg/WAAPCNsAawGmAPQhOb9yrIBpgQAqy0bxMnAYYEJzeuFdBNMCAFGSjeZk4DTAgOL1xr4JogAEpyEbzMnEaYEBweuNeBdEAA1KQjeZl4jTAgOD0hupVqTVuSTtKEBvTvwuQmzoEqr8vqH9LECs/1UuAPJ7+Xx8sLyzULzn9O9RkuFMmDTAgmdSUvVEHBDuSXjsBoBOA7MJ6t5xNoFn5CQAHGJ7eSsvTggHJo61V2iZAKBhMgpB3lik4EwxMXtWd2Z4Byak/T4HotQoVji1IELN9sDzD4Vkvdb37ewYkg64SKPYYDJUyzIK0ySzDkk2fDMgaekqg2JWETtm0GWYrFY7NlKE1y57lvRvIgHTopEBQrIUyw9KlGQYEACIMoXR9mcpZJtirqPJ6gV+VWuNxADh9NlFgVay39OkytCaKGn4VDpD+2vxOAVLlFgxGvifCbBlaI0UDpTCAbKq9vKkFZeUx1HkFv/AaKBQohQCkvza/R4Acx9sE9+zWgAQxXoQzlagBCSz5XjnM6zprMXVFhYr4lWS+Wa9OUwn0TU6UgCR5hjrY8yGcUqVTZUgH1OarylBqBFnjeRUeqj7L0JcCsyO54Kj+nf5xaVvRhl3RAeK4MqWepAdSCLICQGHZ6qEAAAqc9E6YC+8TXcUrGkAceY3TQNiEIQtQDoFZKENr2Dd9ZNHZam2iAMRyEj4tQcws1QdPh0pY5dvs11HetnXreCSG3CR4QCq1xn4LucaKp4hhwxWUHd7WdP4SfG4SLCDJJqtzDVOxdvTXLTrCMHVoakyPEsRIaB439e5BAmI4pFq5sBeLt8gaxpkuiYd6bhIcIAZDKvUeiYlQn3RZQejVzrBnDq7KFRQghuBgMFahxmBVMKi8JAhATN2jkiCGi+4xenkUQ6FXMKVg7wFJ4DjWayNz/n66Wa+O5OxT6ObJASxliTgISLwGJHHzqoxL9eJwSkOTJvKTMrQ2+3yo6C0gBuCI4uBKw77JuiZVRMrSsLd74yUgxHCw1yBD411B1N7E13zQO0CI4eBcwwAcnSIpL4f6GG55BQhlQu7rE8mwvToRT1jp8i5x9waQBA6VkOteeeCQygEmhPvnFSTeAEJ0CDjbrFeHHdgHD5logGgfvYHEC0CIlMpweIIpUV7ixYm7c0CI4OBk3BM40mlQXChVFxyX6oMTLpfmFJAkuVNX1tEvH5SInnzkHWOAxBkgFBUrrlT5TxgFJC7Lv84AIQitvD199d9s7c6QABJnSbsTQHQVxmGVXQOnGC3UPbcOCMFJOSfkFBbrQEaIkFgFhCDv4FKuA8OmHFK3BGw7H7EKiGbewXBQWqpDWZVaQ72/B3tjwur5iDVANN3rQrNe3exwT3loQg3oXkuxmYNaAUQ3tOJyLqF1eiJK97q8rVDLCiA63sPm08IT2ynMNEKwC+OAaHoPzjsix0UnL7XhRYwDoqEAzjsih0MtTzMfMf4ANQqIzpkH5x0FoCNZomY+YvRGhVFAKrWGxGwz5x0YrYXdRyMfMXoNxRggOgvmkm7Yxo6dPfZ8xOQD1RggWO8BAEZdJnbzuJ95DWg8VNVX2xn5fC0jgGgs1HjSZX6beQQdDfjmRYwAgl2kqaeAzoZxX7sa0KhqGclFyAHBvkvQZBxpd4t5NF0NaEQg5OG5CUAwF9H4zEPXqiLrj4xCyEN0UkCwp+bsPSKzboLlYL0IdZhOCgjyrj97DwKDilEE0ouQvqGODBD2HjGaqNs1+eBFyADBLqZZr5LNwe128ujUGsBWtChDdjLjxLhDyoVQbw7L80MDyAcvWbJOAgg2vGLv4YcR+jwLrBehStZJAEFSzsm5z5bp0dwwb5mgik5IAOHwyiNrinAqyMNnkjBLGxBkeMXeI0JDNrkkzEOYIszSBgQTXlG5P5MbwrL90gDmjI3CzrQBwVxr53cL+mV8IcwG+e5U7UhFCxAOr/CmtWlsbnu7Xb4KRPtyCUJ9iNqWTmlSymMlAcdAyIOiJZ4/fn/1ZfxocfR0EWZpAYJJnijcXqjbffHu+U+VBHwJBHwLQJbyrUO0QcCP2iX4xYnvD/4xX984WmPCLN034GkBgsw/hpfqg7NxbFm2VQzUDt0gofxtAHl1th69WonnBLR+uFjf/lSvljH9Hhlmad3N0gIEU58u0uHgwNjhq6HdulcKYeSLRYWU+6FUvmdxcttzMYGw3loQYZZWuRcNCOcf65tkZaxxL0i424rhSrivOVW9x8pYjgfBPJR1yr1oQDDurgj5R/8dBy8onb1hnwT4rE1bkiB/B28t37z04GUnbY5reyxMWK+Th+gAskeAHM+joNjLuwO1xpY2wNMCYHsevVC1lQCHSgDXLdarR6lk+iYH82AGAHQeggYE4+pizj8uGj0yUILl3wshhlwalZRyrg19n3llauuiy3mYHNtmHqIDSN5PTdRKlkwqXFv2uOzrPzX/oivP0T1/5UmWTr5+BTxy5Tvaa/NQgM2HMwoQTIIec/7RX5vbJ0Dc5JMtSZBPLNWHbvZpTlRzwZyHYBN1BkRz1yq1xu0A8FNNMaa6f61Zrz5sSrgrucgDatT5GwoQmxN0tQlZxt1058EPtcob/pmlras25dY7H17Ye9m/XI1vYlxkoo76zCwUIJhSW4wJeqU29xCA+LoJI6CTKX/SrA99g06ee0mYEB9b6kUBgogBtW9Vut+WM2dQuXt+KyzLw77Na9X59IltzfsGjwQx14yTRFSyUKVeLCD7AWBnxrWoZvEBMtrYCwK+k0MH7ppKeKA5Vb3T3QToR0YAgqqiYgHJW+JF0UuvVjqJldG5V0GIC+gkGpQk5cnm1NCFBkewLtpWFGMFkNhKvANjjc9JCb+xbhUaAwoB1y9OVn+rIcKrrghAAJMHMyCIba+Mzf8YpAwr8RXioebk4DcRy/Wyi61CUW5AMBWE2DxIpTb3AoD4iJeWs+ak5IvN+tAVYc157dliAMEcFloBBFti83EzLxr/8/vKpz7who9z6zWn1snXz3vlkSv/26tdCL/HnMUxIBZ29uK7Gh8rteGvFoYiH6Ldgo+f2Fv9G7lgBwK9BQRzihnTNfcQE/TUfkULrl/cG0eibssOc4dYtibm4KGUacj+0fmbhJD7MjX2rJGU4ualqcEnPJsWajq27JABybk9/bsP3SpKpUdzdvOiuWy3b1u6f/tjXkxGcxIMiKYCTXUfGJ37qhRixpR8k3KFLO1anNr2M5Nj2JLNgNjSdM5xKqPznwchf5Wzmx/NpfhCc2rw135MRm8W3gKCOQeJqcxbqR35BEDreb3tddNbtuUnl+4fCnLu3RrztopVdEAGasfPl/BWkJ8cIuDsCxbrG19zgyftqAwIrT5JpVVq8/MAchupUNPCJBxpTlXDmvM6OsGcpPNdLNNGlsiv1OamAcQuS8NRDTPTrFdvoRLmWk5UgOh8LpHrjVht/Eqt8WUA+LmPc1trTlLCV5amqkHNeT39+g7IMQBQH9mf9RXV+0H672ieK8568w0QkPscKavCSNtJkPLtc89berDyJqlch8IQ191Rb9pDbbCtd3M51H/PoSujc4+CELf2bOhDAykfa04N3ebDVKjmgPhsLKuAPA4AueJZTIJEpUwTcvp3z10lSuJPJmRTy4ypvJvqBvHNZqgoButBcgOCuWpMbSjU8iq1xi8B4AZqucTynmrWq18klulUHOaoAfueJCwgynsoSDK/YrrRmy66/66jV4j28t8zK8FBQ1lqf3TpB9tfcDC0sSExp+jYw2oUIDYnaEzLRIIHxuYmpBTfJRJHKkYI+b3FyaE9pEI9EIapYGEf0ChAMC4utlJvp50MjM49a+pbpLD2qL59anFq6Bpsf5/7YQDB5sAoQJTyuJL1rgltvPvQ5vZy6SUAOMcTwzpVWm5fevyB7aocH93LVgVLKc4mIKiPXQlldwdGj3xaitYzHkBySsjytYtTW/8Qiu7yzhNRwUKVeHUB4UpW185urB2+pg3tpx1CcqoEpeuO17c9m9foQmmPCe+xFSxdQHJXsrCVhFA2byX03H3oSlkq7bP9ZTr///q10k2L9W1/CUlfeeeKyT+cAIIhGQBQn4+aV4mu228ZPfLBd0qth0HCjVbmIuDJDe3y7Uentv7byngOB0HkH1qhPToHQSbqEOOB4Vr2UhlrjICU9wGIiwzZ1AkQcE9zsprrTMrQXKyItZl/aIVYCSCch/Qwi0vHD571n1MbRgHgDgA4n8iKXgNoP/j+c1pTL41f9jaRTO/FIKMW1BWTVBm6HiR3HqITD3q/g+tNUEpRGTusPMqNIOBa1FokPANCPNmc3PY4CJH3E/ZRQ/rUyXb+oe1BkCfqhchD1jOsi8devhBaYrhcKl0lQVwuQW4WAFs6+0iAowLEMQHyH9AWz7fKy/tPTF7yqk8Ga3suiLM3wJ6gk3gQzkNsm0hxx0OGV+jzD0pAcuchhQ2zimvf2it3EV5ph1hKADLMWihDa3ihfsmCtuZYQCE0gKheaYdXJIBgwyzd2LAQVsGLXNGAq/CKEpDcYVbMt3vZrmk14Cq8IgMEGWYV6tCQ1mSKIw3pPUjCKzJANMKs8aX64ERxtptXmlcDGO9B+bXjWgeFnYtFfAzLSvciXT3JaxzcfuV9R7kPRCmrpGSAYMMsysWwQcWlAaT3IH3okgGCDbOUO+SSb1yGTbUajPegDK9Ic5AEkNx3s1Q/9iJUJhWPHKz3oH7PEakHYS8Sj4G6Xgnm3hW19yD3IEoglnz2Iq5N0p/xfbIhcg+i4UVIkyt/tptnkkcD2HMPE97DiAdhL5LHHLhttwZ88h7GAEmeAvtzfkUCn4sUnBcN76H1vvP11G4kxNLxIlz2LS4lyMTcaBXUGCA6XoQT9uJBgg2tTOUe6Q4YA0TTi3DCXiBGdEIr0w9To4DoVLQ41CoOIZjPukq0o/2W2l5atgEI6nRdTdz006GXcvj35jWgEVqRXWl3kqR3Doq96cuQmDdQlyNgL7gmc7by6TjGPYhajE7CrvrzlXiXZmxmbJ28w6ZNWAFEN2HnfMSMkbqUqpF3WA29rQGimbBbVYpLwynC2DpwmC7rduvfKiC6oRYn7eHjo5OUJznp8FJ9cNaWJqwCQhBqsSexZRkGxqnUGuiKpquCjXVAdEOtZN9GmvXqtIE9ZJGGNKBZsVKzslK1chpipYPrhlouXK0huymEWAI4jB8IrrURTjwIRahls9RXCCs2tEgCOKwcCHoHCBUk1O9BNmQnhRRLBIfTz05z5kFSi8Fece6yOM5JPENQNyFPluMk7+hUpXNAKPIRVxUOz2zSm+nolnKThTjLO7wCRE2GEpI+WJ7hr1Vwx4rOvbuOWXvzWWnOPQhlZSuRNV2G1gRDYh8SzRPy0xP26asxvAEkSdp3CpDqqxQ2aW6vN08gzXUE0T1Jxin2zWnFajVlewVIR2VLnbjqQqLEcfJuGDGifGNllj55jlRt3gFCWP5N18ghlyFIqEKqZHpePsy8BMQAJAsSxIjNS26GbNILsZQhlc9wqLl5C4iBcEuJZG+iiRhRlcrLhDyIHKR7ksmB0x6inCQV76U717Rdo92JDv7OmKOPOUe3Er32IOlkDbh0JXq2DK0RLgevz1Wie/WA2klJYAhweB9idW4I1WHiKpvMYdcqSkn0rcBQFUXKV1D5YBAeJN0dg5BwfpIo2SAYagQvro/koT0oQNKFEZcXu/VVyNDLVCjVoVznFw/zgJG2DRIQNfnkgIrqQHE13c1KEBN9sLwQc56SJN+7qHOMToWG/FkCwQKSQEJ1NWW9h4uKmadjugSZeIsUCoobC2vpL6h8Y7VFBA1IR8il7gFRJ5OrehUAmClDazZEr2KoZL4WHEGGVN2LiQIQtSjLm6+GVCGY+viZA76GYYlOdiThk0lPcYZdhVLCzZKTRAOIWqzhKlcvfToHRgEhQWwUINWZBem5Ra/FJ7+PrsARFSAdIZcKt6hP3zPayOlmC6qsqf5IEOoniadJHgKp8SvvoDxD+ifvHMnax+Q1OpUSJSBduYkyJmvhRQ6LU9CoV/qz++/pnLt/5hjCfNOQK1RZtBM1IB2VLvKrElmUG3mb6MKpaKtYWQzR0H2uLEPH1ib40m2eDYneg3Qrw0G1K89++NxWVexmivaRr4UDJLVAC1crfDb2PHNbuVFQ1DebFRaQVUBxXgnKY7UW2k5LEDNFBSPVb+EB6QLFxvULC7atNQRf/+9QHwOyii11hF9F8SrsLdZ4pjAgPR62EcOivl/lQNGS7ry+lQHJobEIYGEocuy3asqA5FRY2lxd+ViGPhWC7UjuPvkWjqmy7MoVl1BvHyO3hrQbA0KoTuVhEmA670fZuOay8nV06s6XAHmcwya6TWVA6HS5pqQEHPV7dbkQBMjV7ld1g/Seu1opAEoGewULG8chlh0l8yjhaoA9SLh7xzO3oAEGxIKSeYhwNcCAhLt3PHMLGmBALCiZhwhXAwxIuHvHM7egAQbEgpJ5iHA1wICEu3c8cwsaYEAsKJmHCFcDDEi4e8czt6ABBsSCknmIcDXAgIS7dzxzCxr4H81g7VCVgHyLAAAAAElFTkSuQmCC)
    no-repeat 50%;
  background-size: 100% 100%;
}
/deep/ .jessibuca-container .jessibuca-icon {
  cursor: pointer;
  width: 17px;
  height: 17px;
}
/*选中样式*/
.chosen {
  border: solid 2px #3089dc !important;
}
.dragClass {
  color: red;
  font-weight: bold;
}
.player-w1 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.player-w2 {
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  float: left;
}
.player-w3-1 {
  width: 100%;
  height: 50%;
  box-sizing: border-box;
  float: left;
}
.player-w3-2 {
  width: 50%;
  height: 50%;
  box-sizing: border-box;
  float: left;
}
.list-group {
  width: 100%;
  height: 98%;
  position: absolute;
}

.player-w4 {
  width: 50%;
  height: 50% !important;
  box-sizing: border-box; /**可有可无 */
  float: left;
  padding: 5px;
  position: relative;
  .position_bottom {
    width: 25%;
    position: absolute;
    height: 37px;
    left: 0.46rem;
    right: 0;
    bottom: 0.5rem;
    z-index: 100;
    padding-left: 0.7692rem;
    // line-height: 2.375rem;
    // opacity: 0.5;
    .title {
      height: 28px;
      line-height: 28px;
      color: #fff;
      width: 100%;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      font-size: 1.0769rem;
      margin-top: 1px;
    }
  }
  .position_top {
    position: absolute;
    left: 0;
    right: 0.2rem;
    top: 0.5rem;
    z-index: 100;
    padding: 0px 0.538461rem;
    .title {
      height: 2.92307rem;
      line-height: 2.92307rem;
      color: #fff;
      width: 15rem;
      display: inline-block;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      background: #000;
      // opacity: 0.5;
      font-size: 1.0769rem;
      // margin-top: 1px;
      text-align: left;
      opacity: 0.2;
    }
    .title:hover {
      opacity: 1;
    }
  }
  .icon_con_close {
    display: inline-block;
    width: 1.2307rem;
    height: 1.2307rem;
    line-height: 1.2307rem;
    text-align: center;
    border-radius: 2px;
    vertical-align: middle;
    margin-top: 0.675rem;
    background: #202223;
    color: #6e777e;
  }
  .icon_con {
    // display: inline-block;
    width: 1.2307rem;
    height: 1.2307rem;
    // line-height: 2.07rem;
    text-align: center;
    border-radius: 2px;
    // vertical-align: middle;
    // margin-right: 1.375rem;
    margin: auto;
    color: #197ad7;
  }
  .iconfont {
    font-size: 1.2307rem;
  }
}
.player-w6-1 {
  width: 66.66%;
  height: 65.66% !important; /*这里小一点 注意点 */
  box-sizing: border-box;
  float: left;
}
.player-w6-2 {
  width: 33.33%;
  height: 33.33% !important;
  box-sizing: border-box;
  display: inline-table; /**可有可无 */
  float: left;
}
.player-w8-1 {
  width: 75%;
  height: calc(75% - 0.5rem) !important;
  box-sizing: border-box;
  float: left;
  padding: 5px 5px 0px 5px;
  position: relative;
  .position_bottom {
    width: 25%;
    height: 38px;
    // line-height: 3.61538rem;
    position: absolute;
    left: 0.8rem;
    right: 0;
    bottom: 0;
    z-index: 100;

    .title {
      display: none;
      height: 2.1538rem;
      line-height: 2.1538rem;
      color: #fff;
      width: 100%;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      font-size: 1.0769rem;
      opacity: 0.2;
      // margin-top: 1px;
    }
  }
  .position_top {
    position: absolute;
    left: 0;
    right: 0.2rem;
    top: 0.5rem;
    z-index: 100;
  }
  .icon_con_close {
    display: inline-block;
    width: 1.2307rem;
    height: 1.2307rem;
    line-height: 1.2307rem;
    text-align: center;
    border-radius: 2px;
    vertical-align: middle;
    margin-right: 0.675rem;
    margin-top: 0.675rem;
    background: #202223;
    color: #6e777e;
  }
  .icon_con {
    // display: inline-block;
    width: 1.3307rem;
    height: 1.3307rem;
    text-align: center;
    border-radius: 2px;
    // vertical-align: middle;
    margin-right: 1.375rem;
    color: #197ad7;
  }
  .iconfont {
    font-size: 1.2307rem;
  }
  .title {
    height: 2.92307rem;
    line-height: 2.92307rem;
    margin-left: 0.62307rem;
    color: #fff;
    width: 20rem;
    display: inline-block;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    background: #000;
    // opacity: 0.5;
    font-size: 1.0769rem;
    opacity: 0.2;
    // margin-top: 1px;
  }
  .title:hover {
    opacity: 1;
  }
}
.player-w8-2 {
  width: 25%;
  height: 25% !important;
  box-sizing: border-box;
  display: inline-table; /**可有可无 */
  float: left;
  padding: 5px;
  position: relative;
  span {
    display: none;
  }
  /deep/ .jessibuca-container .jessibuca-icon {
    cursor: pointer;
    width: 15px;
    height: 15px;
  }
  .icon_con_close {
    display: inline-block;
    width: 1.2307rem;
    height: 1.2307rem;
    line-height: 1.2307rem;
    text-align: center;
    border-radius: 2px;
    vertical-align: middle;
    margin-right: 0.675rem;
    margin-top: 0.675rem;
    background: #202223;
    color: #6e777e;
    span {
      display: block;
    }
  }
  /deep/.jessibuca-container .jessibuca-controls {
    // height: 15px;
  }
  .position_bottom {
    width: 25%;
    height: 1.5076rem;
    line-height: 1.5076rem;
    position: absolute;
    left: 0.5rem;
    right: 0;
    bottom: 0.5rem;
    z-index: 100;
    padding-left: 0.5rem;
    .title {
      color: #fff;
      width: 20rem;
      display: inline-block;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      // opacity: 0.5;
      font-size: 0.769rem;
      // margin-top: 1px;
    }
    .icon_con {
      display: none;
    }
  }
  .position_top {
    position: absolute;
    left: 0;
    right: 0.2rem;
    top: 0.5rem;
    z-index: 100;
    .title {
      display: none;
    }
  }
}
.player-9 {
  width: 33.33%;
  height: 33.33% !important;
  box-sizing: border-box;
  float: left;
}
.player-16 {
  width: 25%;
  height: 25% !important;
  box-sizing: border-box;
  float: left;
}
/deep/ .el-dropdown {
  display: block;
}
</style>
